import { FC } from "react";
import { FormattedMessage } from "react-intl";

type UploadsBannerProps = {
  visible: boolean;
};

export const UploadsBanner: FC<UploadsBannerProps> = ({ visible }) => {
  return (
    <div
      className={`fixed bottom-0 left-0 right-0 w-screen z-50 flex items-center justify-center pt-2 pb-4 px-4 transition-all duration-300 ease-in-out ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
    >
      <div className="px-4 py-2 bg-orange-500 rounded-md shadow-[0px_2px_4px_-1px_rgba(0,0,0,0.06)] shadow-md inline-flex flex-col justify-start items-start gap-4">
        <div className="text-center justify-start text-orange-50 text-sm font-semibold leading-tight">
          <FormattedMessage
            id="uploadsBanner.dontCloseTab"
            defaultMessage="Don't close this tab"
          />
        </div>
      </div>
    </div>
  );
};
